import { useState } from "react";
import { updateInvoicePayment } from "../../api/invoiceService";

export const useUpdateInvoicePayment = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (id, data) => {
    setUpdating(true);
    try {
      const updatedRecord = await updateInvoicePayment(id, data);
      setUpdating(false);
      if (successCallback) successCallback(updatedRecord);
      return updatedRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update invoice payment:", error);
      throw error;
    }
  };

  return { update, updating };
};